$.fn.Product = function() {
  let self = this
  self.product = self.find('.product')

  self.initialize_product = function() {
    self.find('.summary form.cart').CartForm({
      select: true,
      main: self.find('.summary-container'),
      parent: self.find('.summary-container'),
    })
    self.find('.product-bar form.cart').CartForm({
      main: self.find('.summary-container'),
      parent: self.find('.product-bar'),
    })
  }

  self.initialize_scroll = function() {
    self.find('.summary-container').FixedContent({
      bottomBlocker: $('.page-section:nth-child(2), .footer').first(),
      limitFromTop: self.find('.summary-container').offset().top,
    })
    $(window).on('resize orientationchange load', function() {
      self.find('.entry-summary').css({
        'min-height': self.find('.summary-container').outerHeight(true) + 'px',
      })
    })
  }

  return function() {
    self.initialize_product()
    self.initialize_scroll()
    return self
  }()
}
